<template>
  <li>
    <img :src="imageSrc" class="serviceLogo" />
  </li>
</template>

<script>
export default {
  name: 'ServiceLogo',
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.serviceLogo {
  height: 100%;
}
</style>
